import { render, staticRenderFns } from "./knowledge-panel-kommentar.vue?vue&type=template&id=06c0d3a3&scoped=true"
import script from "./knowledge-panel-kommentar.vue?vue&type=script&lang=ts"
export * from "./knowledge-panel-kommentar.vue?vue&type=script&lang=ts"
import style0 from "./knowledge-panel-kommentar.vue?vue&type=style&index=0&id=06c0d3a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_css-loader@4.3.0_webpack@4.46.0__ejs@3.1.10_0212d38a6ce0de8ef75b0a1c6dc51def/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0d3a3",
  null
  
)

export default component.exports